'use client';

import { useEffect, useState } from 'react';
import Loader from './Loader';

const Preloading = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        document.body.style.overflow = 'hidden';

        setTimeout(() => {
            setIsLoaded(true);
            document.body.style.overflow = 'auto';
        }, 2000);

        if (isLoaded) {
            setTimeout(() => setIsVisible(false), 1000);
        }
    }, [isLoaded]);

    if (!isVisible) return null;

    return (
        <div
            className={`w-screen h-screen fixed inset-0 z-50 bg-white transition-opacity duration-700 ${
                isLoaded ? 'opacity-0' : 'opacity-100'
            }`}
        >
            <Loader />
        </div>
    );
};

export default Preloading;
